<template>
	<div class="newRulesDetails">
		<el-table ref="multipleTable" class="qcTable scrollbar" :data="setList" height="300" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="80"></el-table-column>
			<el-table-column prop="Type" label="类型">
				<template slot-scope="scope">
					<span v-show="scope.row.Type == 1">影像</span>
					<span v-show="scope.row.Type == 2">报告</span>
					<span v-show="scope.row.Type == 3">病史</span>
					<span v-show="scope.row.Type == 0">全部</span>
				</template>
			</el-table-column>
			<el-table-column prop="Description" label="细则"></el-table-column>
			<el-table-column prop="ModalityType" label="设备">
				<template slot-scope="scope">
					{{ scope.row.ModalityType }}
				</template>
			</el-table-column>
			<el-table-column prop="Score" label="分值"></el-table-column>
		</el-table>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
	data() {
		return {
			img: [],
			report: []
		};
	},
	props: {
		setList: {},
		choiceList: {}
	},
	computed: {
		...Vuex.mapState('managerPlan', [])
	},
	methods: {
		...Vuex.mapMutations('managerPlan', ['setNewSchemeImgReporttList']),
		...Vuex.mapActions('managerPlan', ['']),
		handleSelectionChange(val) {
			this.setNewSchemeImgReporttList({
				type: 'special',
				data: val
			});
		},
		echo() {
			this.choiceList.forEach(row => {
				this.$refs.multipleTable.toggleRowSelection(
					this.setList.find(item => {
						return row.ScoreItemGuid == item.ScoreItemGuid;
					}),
					true
				);
			});
		}
	}
};
</script>
